import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/person 2.jpg")